module.exports = __webpack_public_path__ + "img/chat.8f266f02.png";